/**
 * Helper function to copy HTML content to clipboard with formatting preserved
 * Copies HTML with styles, links, and images that can be pasted into email clients
 * @param htmlContent - HTML string to copy
 * @throws Error if clipboard operation fails
 */
export const copyHtmlToClipboard = (htmlContent: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    try {
      // Create temporary element for selection
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlContent;
      tempDiv.style.position = 'fixed';
      tempDiv.style.left = '-9999px';
      document.body.appendChild(tempDiv);

      // Set up copy event handler to include HTML
      const copyHandler = (e: ClipboardEvent) => {
        e.clipboardData?.setData('text/html', htmlContent);
        // Also set plain text as fallback
        const textContent = tempDiv.innerText || tempDiv.textContent || '';
        e.clipboardData?.setData('text/plain', textContent);
        e.preventDefault();
      };

      document.addEventListener('copy', copyHandler);
      const range = document.createRange();
      range.selectNodeContents(tempDiv);
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(range);
      document.execCommand('copy');
      document.removeEventListener('copy', copyHandler);

      document.body.removeChild(tempDiv);
      selection?.removeAllRanges();

      resolve();
    } catch (error) {
      console.error('Failed to copy HTML to clipboard:', error);
      reject(error);
    }
  });
};
